import { render } from "./PickUpTalents.vue?vue&type=template&id=ac62b3d0&scoped=true&ts=true&lang=pug"
import script from "./PickUpTalents.vue?vue&type=script&lang=ts"
export * from "./PickUpTalents.vue?vue&type=script&lang=ts"

import "./PickUpTalents.vue?vue&type=style&index=0&id=ac62b3d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac62b3d0"]])

export default __exports__